
import { Component } from 'react';
import PropTypes from 'prop-types';

import removeItem from 'lodash-es/remove';
import merge from 'lodash-es/merge';

import options from '../../data/options.json';

import Courses from './Index.jsx';
import Navigation from '../Navigation.jsx';
import unpackCourses from '../../functions/unpackCourses.js';
import { wrap } from 'lodash-es';

options.courses.courseType = (typeof lineTypeChoices !== 'undefined') ? lineTypeChoices : [];

const defaultFilters = {
    active: false,
    courses: {
        name: '',
        category: [],
        subCategory: [],
        christian: null,
        hc: '',
        region: null,
        courseType: null,
        price: null,
        lt: ''
    },
};

const hashKeys = {
    name: 'q',
    // category: 'c',
    // subCategory: 's',
    christian: 'v',
    hc: 'h',
    region: 'l',
    courseType: 't',
    price: 'p',
    lt: 'lt'
};


const filters = { ...defaultFilters };
const categories = window.mainCategories;

export default class CoursesContainer extends Component {
    constructor(props) {
        super(props);
        unpackCourses(props.courses, categories, props.schools);

        this.state = {
            courses: props.courses,
            facets: props.facets,
            categories: window.categoryTree,
            selectedSubCategories: {},
            options,
            filters,
            isRestplass: (props.restplassCount > 0),
            searchParams: {},
            courseOffset: 14
        };

        this.setCoursesFilters = this.setCoursesFilters.bind(this);
        this.filterCourses = this.filterCourses.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.showWholeyearCourses = this.showWholeyearCourses.bind(this);
        this.showHalfyearCourses = this.showHalfyearCourses.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.navigationActive = false;
        this.debounceLoad = null;

        this.regionSlugs = [];

        for (let i=0; i<options.courses.region.length; i++) {
            let slug = options.courses.region[i].name.toLowerCase().replace('ø', 'o').replace('-', '');
            this.regionSlugs[slug] = options.courses.region[i].key;
        }

        window.addEventListener('hashchange', this.hashChange.bind(this), false);
        window.addEventListener('popstate', this.hashChange.bind(this), false);
    }

    showWholeyearCourses() {
        this.setCoursesFilters('w', 'courseType');
        this.scrollToCourses();
    }

    showHalfyearCourses() {
        this.setCoursesFilters([
            options.courses.courseType[1].key,
            options.courses.courseType[2].key
        ], 'courseType');
        this.scrollToCourses();
    }

    scrollToCourses() {
        document.getElementById('linjer').scrollIntoView({
            behavior: 'smooth'
        });
    }

    setSingleCategory(cat, callback) {
        const categoryFilter = {
            category: [],
            subCategory: []
        };
        if (categorySlugs[cat]) {
            categoryFilter.category.push(categorySlugs[cat].main);
            categoryFilter.subCategory.push(categorySlugs[cat].cat);
        }
        else {
            for (let catName in this.state.categories) {
                if (this.state.categories[catName].slug === cat) {
                    categoryFilter.category.push(this.state.categories[catName].name);
                }
            }
        }
        if (categoryFilter.category.length || categoryFilter.subCategory.length) {
            this.setState((previousState) => {
                return merge(
                    previousState,
                    {
                        filters: {
                            active: true,
                            courses: {
                                category: categoryFilter.category,
                                subCategory: categoryFilter.subCategory
                            }
                        }
                    }
                );
            }, callback);
        }
    }

    loadMore(amount, callback) {
        let courseOffset = this.state.courseOffset;
        fetch('/coursedata', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                lang: this.props.lang,
                restplass: this.state.isRestplass,
                offset: courseOffset,
                limit: amount,
                filters: this.state.searchParams
            })
        }).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    unpackCourses(data.courses, categories, this.props.schools);
                    const courses = this.state.courses.concat(data.courses);
                    this.setState({ courses: courses }, () => {
                        this.forceUpdate();
                    });
                });
            }
        });
        courseOffset += amount;
        this.setState({ courseOffset });
    }

    loadCourses() {
        this.setState({ courseOffset: 14 });
        fetch('/coursedata', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                forceneworder: true,
                lang: this.props.lang,
                restplass: this.state.isRestplass,
                offset: 0,
                limit: 14,
                filters: this.state.searchParams
            })
        }).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    unpackCourses(data.courses, categories, this.props.schools);
                    this.setState({
                        courses: data.courses,
                        facets: data.facets
                    }, () => {
                        this.forceUpdate();
                    });
                });
            }
        });
    }

    hashChange() {
        let params = location.hash.substring(1).split('|');
        let filters = {};
        let cat = '';
        let regionValue = null;

        if (params[0].indexOf(':') === -1 && params[0] !== 'linjer') {
            // fetch main category from hash - old link method
            cat = params.shift();
        }

        if (cat === '') {
            const pathParts = location.pathname.split('/');
            if (pathParts.length > 2 && pathParts[1] === 'linjer') {
                cat = pathParts[2];
            }
            for (let i=0; i<pathParts.length; i++) {
                if (pathParts[i] === 'region' && pathParts.length > i+1) {
                    let regionParam = pathParts[i+1];
                    if (this.regionSlugs[regionParam]) {
                        regionValue = this.regionSlugs[regionParam];
                    }
                }
            }
        }

        if (cat === 'region') {
            cat = '';
        }

        if (cat) {
            this.setSingleCategory(cat, () => {
                if (!params.length && !regionValue) {
                    // only load courses if we don't have more parameters to set to prevent double loading
                    this.loadCourses();
                }
            });
        }

        if (params.length || regionValue) {
            for (let i=0; i<params.length; i++) {
                let param = params[i].split(':');
                if (param.length === 2) {
                    let filter = decodeURIComponent(param[1]).split(/,|;/);
                    filters[param[0]] = filter;
                }
            }
            if (regionValue) {
                filters.region = regionValue;
            }
            const newFilters =
            {
                filters: merge(
                    this.state.filters,
                    {
                        active: true,
                        courses: filters
                    }
                )
            };
            this.setState(newFilters, () => this.filterCourses());
        }
        else {
            this.filterCourses();
        }

        if (params[0] === 'linjer') {
            setTimeout(() => {
                let wrapper = document.querySelector('.filter__labelswrapper');
                if (wrapper) {
                    wrapper.scrollIntoView();
                }
            }, 500);
        }
    }

    componentDidMount() {
        this.hashChange();
    }

    updateResultHash() {
        let state = this.state.filters.courses;
        let params = [];
        let categorySlug = '';

        if (state.subCategory.length) {
            let option = state.subCategory[state.subCategory.length - 1];
            let subCategories = [];
            for (let slug of Object.keys(categorySlugs)) {
                if (categorySlugs[slug].cat == option) {
                    categorySlug = slug;
                }
                if (state.subCategory.includes(categorySlugs[slug].cat)) {
                    subCategories.push(categorySlugs[slug].cat);
                }
            }
            if (subCategories.length) {
                params.push('subCategory:' + subCategories.join(';'));
            }
        }
        if (state.category.length) {
            let option = state.category[state.category.length - 1];
            let categories = [];
            for (let item of Object.values(this.state.categories)) {
                if (item.name == option && !categorySlug) {
                    categorySlug = item.slug;
                }
                if (state.category.includes(item.name)) {
                    categories.push(item.name);
                }
            }
            if (categories.length) {
                // params.push('category:' + categories.join(';'));
            }
        }

        for (let key in state) {
            if (hashKeys[key] && state[key]) {
                let value = state[key];
                if (Array.isArray(state[key])) {
                    value = state[key].join(';');
                }
                params.push(key + ':' + state[key]);
            }
        }

        // If only a subcategory is selected, update the current url to a nice url with the category slug in it
        if (params.length === 1 && params[0].indexOf('subCategory:') !== -1) {
            let categoryName = params[0].split(':')[1];
            for (let slug of Object.keys(categorySlugs)) {
                if (categorySlugs[slug].cat == categoryName) {
                    categorySlug = slug;
                }
            }
            params = [];
        }

        let url = '/';

        if (this.props.lang === 'en') {
            url += 'en/courses/';
        }

        if (params.length) {
            url = '#' + params.join('|');
        }

        if (categorySlug !== '') {
            let uri = (this.props.lang !== 'en' ? 'linjer/' : '') + categorySlug;
            FHS.updatePageview(url);
            url = url + uri;
        }

        if (this.navigationActive) {
            history.pushState('', '', url);
        }
        else {
            history.replaceState('', '', url);
            this.navigationActive = true;
        }
    }

    getChristianFilter(field) {
        let christianFilter = '';

        if (field && field.length) {
            let atheist = field.includes("false");
            let christian = field.includes("true");
            if (atheist && !christian) {
                christianFilter = false;
            }
            else if (!atheist && christian) {
                christianFilter = true;
            }
        }

        return christianFilter;
    }

    setCoursesFilters(field, type, remove) {
        let debounceTime = 0;
        let newFilters = null;
        if (type === 'hc') {
            newFilters = { hc: field };
        }
        else if (type === 'christian') {
            newFilters = {
                christian: field.length ? field : null
            };
        }
        else if (type === 'courseType') {
            if (field.length) {
                if (typeof field === 'string') {
                    field = [field];
                }
                newFilters = { courseType: field };
            }
            else {
                newFilters = { courseType: null };
            }
        }
        else if (type === 'region') {
            newFilters = {
                region: field.length ? field : null
            };
        }
        else if (type === 'lt') {
            newFilters = {
                lt: field.length ? field : null
            };
        }
        else if (type === 'category') {
            let categoryFilter = this.state.filters.courses.category;
            let subCategoryFilter = this.state.filters.courses.subCategory;
            let oldIndex = categoryFilter.indexOf(field);
            if (remove) {
                if (oldIndex !== -1) {
                    categoryFilter.splice(oldIndex, 1);
                    for (const category in window.categoryTree) {
                        if (window.categoryTree[category].name === field) {
                            for (const child in window.categoryTree[category].children) {
                                let catName = window.mainCategories[window.categoryTree[category].children[child].id];
                                if (subCategoryFilter.includes(catName)) {
                                    removeItem(subCategoryFilter, (el) => el === catName);
                                }
                            }
                        }
                    }
                }
            } else if (oldIndex === -1) {
                categoryFilter.push(field);
            }
            newFilters = {
                category: categoryFilter,
                subCategory: subCategoryFilter
            };
        }
        else if (type === 'subCategory') {
            let categoryFilter = this.state.filters.courses.subCategory;
            let oldIndex = categoryFilter.indexOf(field);
            if (remove) {
                if (oldIndex !== -1) {
                    categoryFilter.splice(oldIndex, 1);
                }
            } else if (oldIndex === -1) {
                categoryFilter.push(field);
            }
            newFilters = { subCategory: categoryFilter };
        }
        else if (type === 'price') {
            newFilters = {
                price: field.length ? field : null
            };
        }
        else if (type === 'search') {
            newFilters = {
                name: field
            };
            if (field) {
                debounceTime = 1500;
            }
        }

        if (newFilters) {
            let filters = merge(
                this.state.filters,
                {
                    active: true,
                    courses: newFilters
                }
            );
            if (type === 'price') {
                filters.courses.price = newFilters.price;
            }
            this.setState({ filters }, () => {
                this.debounceLoad = setTimeout(() => {
                    this.filterCourses();
                }, debounceTime)
            });
        }

        return null;
    }

    setCategory(option, type, remove) {
        return () => {
            if (type === 'category') {
                FHS.track('linjesøk', 'kategori', option);
            } else if (type === 'subCategory') {
                FHS.track('linjesøk', 'underkategori', option);
            }
            this.setCoursesFilters(option, type, remove);
        };
    }

    getFreetextFilter() {
        const coursesFilters = filters.courses;
        if (typeof coursesFilters.name === 'object') {
            coursesFilters.name = coursesFilters.name[0];
        }
        return coursesFilters.name.toLowerCase()
    }

    filterCourses() {
        if (!this.state.filters.active) {
            return;
        }

        const coursesFilters = this.state.filters.courses;

        const searchParams = {
            type: coursesFilters.courseType,
            christian: this.getChristianFilter(coursesFilters.christian),
            region: coursesFilters.region,
            price: coursesFilters.price,
            query: this.getFreetextFilter(),
            category: [],
            subCategory: []
        };

        if (searchParams.query) {
            FHS.track('linjesøk', 'søk', searchParams.query);
        }

        if (coursesFilters.subCategory.length) {
            let subCategories = [];
            for (let slug of Object.keys(categorySlugs)) {
                if (coursesFilters.subCategory.includes(categorySlugs[slug].cat)) {
                    subCategories.push(categorySlugs[slug].id);
                }
            }
            if (subCategories.length) {
                searchParams.subCategory = subCategories;
            }
        }

        if (coursesFilters.category.length) {
            let categories = [];
            for (let item of Object.values(this.state.categories)) {
                if (coursesFilters.category.includes(item.name)) {
                    // do not include main categories with selected child categories in filtering
                    // - they cause some courses to lack in result
                    let hasSelectedChildren = false;
                    for (let mainCategory of categoryTree) {
                        if (mainCategory.id === item.id) {
                            for (let childCategory of mainCategory.children) {
                                if (searchParams.subCategory.includes(childCategory.id)) {
                                    hasSelectedChildren = true;
                                    break;
                                }
                            }
                        }
                        if (hasSelectedChildren) {
                            break;
                        }
                    }
                    if (!hasSelectedChildren) {
                        categories.push(item.id);
                    }
                }
            }
            if (categories.length) {
                searchParams.category = categories;
            }
        }

        this.updateResultHash();

        this.setState({ searchParams }, () => {
            this.loadCourses();
        });
    }

    resetFilters() {
        this.setState({
            // filteredCourses: this.deterministicShuffle(this.props.courses, true),
            filters: {
                active: false,
                courses: {
                    name: '',
                    category: '',
                    subCategory: '',
                    christian: '',
                    hc: '',
                    region: '',
                    courseType: '',
                    price: '',
                },
            },
        });
        history.pushState('', '', '/linjer');
    }

    render() {
        let navigation = this.props.lang === 'no' ? <Navigation courses="this.props.courses" /> : '';
        return (
            <div>
                {navigation}
                <Courses
                    filteredCourses={this.state.courses}
                    facets={this.state.facets}
                    filterCourses={this.setCoursesFilters}
                    categories={this.state.categories}
                    categoryCounts={this.state.categoryCounts}
                    mainCategoryCounts={this.state.mainCategoryCounts}
                    filtersActive={this.state.filters.active}
                    filters={this.state.filters}
                    resetFilters={this.resetFilters}
                    options={this.state.options}
                    setCategory={this.setCategory}
                    showWholeyearCourses={this.showWholeyearCourses}
                    showHalfyearCourses={this.showHalfyearCourses}
                    isRestplass={this.state.isRestplass}
                    lang={this.props.lang}
                    loadMore={this.loadMore}
                    pageOffset={this.state.courseOffset}
                />
            </div>
        );
    }
}

CoursesContainer.propTypes = {
    courses: PropTypes.array,
    schools: PropTypes.array,
    lang: PropTypes.string,
    facets: PropTypes.object
};

CoursesContainer.contextTypes = {
    router: PropTypes.object,
    location: PropTypes.object
}
